export const API_URL = "https://firewithin.coachgenie.in/old_code/";
export const APP_URL = "https://firewithin.coachgenie.in/";
//export const APP_URL = "http://localhost:3000";

// export const API_URL ="https://e-book.inductothermgroup.com/old_code/";
// export const APP_URL ="https://e-book.inductothermgroup.com/";


